<div class="col-md-12 " >
    <div class="row">
    <mat-form-field class=" col-md-3 mt-1  "  >
      <input matInput   [(ngModel)]="searchText"   placeholder="Search..." autocomplete="off" (input)="searchSource()"  >
    
    </mat-form-field>
    <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]"
    [length]="totalElements"
    (page)="nextPage($event)"
    aria-label="Select page">
    </mat-paginator>
    
    </div>
    
    <table mat-table
    [dataSource]="fareeList" multiTemplateDataRows style="background-color: transparent;">
   
    <!-- <ng-container matColumnDef="code">
     <th mat-header-cell *matHeaderCellDef> Code </th>
     <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
    </ng-container> -->
     <ng-container matColumnDef="carrier">
       <th mat-header-cell *matHeaderCellDef>Carrier</th>
       <td mat-cell *matCellDef="let element"  > {{filterCarrier(element?.carrier)}} </td>
     </ng-container>
     <!-- style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" -->
     <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef> Source </th>
      <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);cursor: pointer;" (click)="rowClick(element)"> {{filterSource(element?.source)}} </td>
     </ng-container>
    <ng-container matColumnDef="priority">
     <th mat-header-cell *matHeaderCellDef> Priority </th>
     <td mat-cell *matCellDef="let element" > 
      {{element?.priority}}
    </td>
    </ng-container>
    
     <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type </th>
      <td mat-cell *matCellDef="let element"> 
        <span *ngIf="element?.allow==='true'">Allow</span>
        <span *ngIf="element?.allow==='false'">Disallow</span>

         </td>
     </ng-container>
     <ng-container matColumnDef="class">
        <th mat-header-cell *matHeaderCellDef>Class </th>
        <td mat-cell *matCellDef="let element"> {{element?.classTypes }} </td>
       </ng-container>
       <ng-container matColumnDef="fareType">
        <th mat-header-cell *matHeaderCellDef>Fare Type</th>
        <td mat-cell *matCellDef="let element"> {{element?.fareType}} </td>
       </ng-container>
       <ng-container matColumnDef="basis">
        <th mat-header-cell *matHeaderCellDef>Basis </th>
        <td mat-cell *matCellDef="let element"> {{element?.fareBasisRegex}} </td>
       </ng-container>
       <ng-container matColumnDef="flight">
        <th mat-header-cell *matHeaderCellDef>Flight </th>
        <td mat-cell *matCellDef="let element"> {{element?.flightRegex}} </td>
       </ng-container>
      
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDisplay.length">
    <div class="example-element-detail row"
     [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
    
    </div>
    </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="columnsDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsDisplay;"
    class="example-element-row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    <tr class="mat-row" *matNoDataRow>
    <td  class="mat-cell" colspan="4">There is no data in this table</td>
    </tr>
    </table>
    
    
    </div>

    <div class="modal " id="myMod"  [style.display]="addfare.boolean ? 'block' : 'none'" >
      <div class="modal-dialog" >
          <div class="modal-content " >
              <div class="modal-header title">
                <h4 *ngIf="addfare.action==='newFare'" class="modal-title">Add Fare / Rules</h4>
                <h4  *ngIf="addfare.action==='updateFare'" class="modal-title">Edit Fare / Rules</h4>

                <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                </div>
                <div class="modal-body">
                <div class="col-md-12 mt-3 " *ngIf="addfare.boolean">
                  <div class="col-md-12 d-flex justify-content-center" >
                  <div class="col-md-12 row " style="overflow: auto; max-height: 60vh;" >
                      <div class=" col-md-12 ">
                        
                          <form [formGroup]="fareRegFg"  autocomplete="off"  class="  pt-3" >
                            <div formGroupName="applyTo" class="row">
                            <mat-form-field  class="col-md-3" appearance="outline">
                              <mat-label>Air Type	</mat-label>
                              <mat-select matNativeControl name="airProduct"  formControlName="airType" >
                                  <mat-option value="I">International</mat-option>
                                  <mat-option value="D">Domestic</mat-option>
                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Source	</mat-label>
                              <mat-select matNativeControl name="source"  formControlName="source" >
                                <mat-option *ngFor="let item of sourceCodeList" [value]="item.code">{{item.title}}</mat-option>
                              </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Carrier	</mat-label>
                              <mat-select matNativeControl name="carrier" formControlName="carrier" (selectionChange)="getfarelist($event)" >
                                <mat-option *ngFor="let item of carrierList" [value]="item?.airlineDesignatorCode">{{ item.carrierName }}</mat-option>
                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Fare Type</mat-label>
                              <mat-select matNativeControl name="carrier" formControlName="fareMapping"  >
                                <mat-option *ngFor="let item of farelist" [value]="item.fareType">{{item?.fareTypeDisplay}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Priority	</mat-label>
                              <mat-select matNativeControl name="airProduct" formControlName="priority" >
                                <mat-option *ngFor="let number of numbers" [value]="number.toString()">{{ number }}</mat-option>
                              </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Class</mat-label>
                              <input matInput name="class" autocomplete="off" maxlength="36" formControlName="classTypes">

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Source Groups	</mat-label>
                              <input matInput name="group" autocomplete="off" formControlName="sourceGroups">


                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Status	</mat-label>
                              <mat-select matNativeControl name="status" formControlName="status" >
                                  <mat-option value="A">Enabled</mat-option>
                                  <mat-option value="I">Disabled</mat-option>

                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline" >
                              <mat-label>Type</mat-label>
                              <mat-select matNativeControl name="type" formControlName="allow" >
                                  <mat-option value="true">Allow</mat-option>
                                  <mat-option value="false">Disallow</mat-option>

                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Fare Type	</mat-label>
                              <mat-select matNativeControl name="fareType"  formControlName="fareType">
                                <!-- <mat-option value="nonReschedulable">Non-Reschedulable</mat-option> -->
                                  <!-- <mat-option value="nonRefundable">Non-Refundable</mat-option> -->
                                  <mat-option value="DEFAULT">Default</mat-option>
                                  <mat-option value="REFUNDABLE">Refundable</mat-option>
                                  <!-- <mat-option value="checkFare">Check Fare</mat-option> -->
                                  <!-- <mat-option value="any">Any</mat-option> -->

                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Hide Result	</mat-label>
                              <mat-select matNativeControl name="hideResult" formControlName="hideResult" >
                                  <mat-option value="true">YES</mat-option>
                                  <mat-option value="false">NO</mat-option>

                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Basis Regex		</mat-label>
                              <input matInput name="BasisRegex" maxlength="36" autocomplete="off" formControlName="fareBasisRegex" >


                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Flight Regex	</mat-label>
                              <input matInput name="flightRegex" autocomplete="off" maxlength="36" formControlName="flightRegex">


                            </mat-form-field>
                            
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Product Class	</mat-label>
                              <input matInput name="productClass" autocomplete="off" maxlength="36" formControlName="productClass">


                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Private Fare Code Regex</mat-label>
                              <input matInput name="CodeRegex" autocomplete="off" maxlength="36" formControlName="privateFareCodeRegex">


                            </mat-form-field>
                          </div>   

                            </form>
                      </div>

                      <div class="modal-header title " style="max-height: 50px;">
                        <h4  class="modal-title">Fare Properties</h4>
                      
                        </div>
                        <div class=" col-md-12 pt-3">
                        
                          <form [formGroup]="fareRegFg"   autocomplete="off"  class=" row" >
                            <div formGroupName="changeTo" class="row">

                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Baggage Wt(set zero for no baggage)	</mat-label>
                              <input matInput name="baggage" autocomplete="off" maxlength="36" formControlName="baggageWeight"   (keypress)="onlyNumberKey($event)" >


                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline" >
                              <mat-label>Refundability Indicator		</mat-label>
                              <mat-select matNativeControl name="refundability"  formControlName="refundIndicator">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>

                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Free Meal Indicator		</mat-label>
                              <mat-select matNativeControl name="freeMeal"  formControlName="freeMealIndicator">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>

                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Fetch from API?	</mat-label>
                              <mat-select matNativeControl name="fetchApi"   formControlName="fetchFromAPI">
                                  <mat-option value="true">True</mat-option>
                                  <mat-option value="false">False</mat-option>

                                </mat-select>

                            </mat-form-field>
                           
                            
                            <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Fare Family	</mat-label>
                              <mat-select matNativeControl name="fareFamily"  formControlName="fareFamily">
                                  <mat-option value="familyFare">Family Fare</mat-option>
                                  <mat-option value="advanceFare">Advance Purchase Fare</mat-option>

                                </mat-select>

                            </mat-form-field>
                            
                          </div>
                                        
                            </form>
                      </div>
                      <div class="modal-header title" style="max-height: 50px;">
                        <h4  class="modal-title">Fare Rules </h4>
                      
                        </div>

  <div class=" col-md-12 pt-3">
                        
                          <form [formGroup]="fareRegFg"  autocomplete="off"   >
                            <div formGroupName="rule" class="row">
                              <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="pb-2" style="text-align: left; overflow-y: auto;max-height: 60vh;">
                                <mat-tab  label="Change Rule">  

                                  <div class="schedule-container">
                                    <form  >
                                      <div style="padding: 15px;" *ngFor="let schedule of changeRule ; let i = index" [ngClass]="{'odd-row': i % 2 !== 0, 'even-row': i % 2 === 0}">
                                        <h3>Schedule {{ i + 1 }}</h3>
                                        <div class="col-md-12 row">
                                        <div class="col-md-6">
                                          <label>From:</label>
                                          <input type="text" [(ngModel)]="schedule.from" name="from{{ i }}" />
                                        </div>
                                        <div class="col-md-6">
                                          <label>To:</label>
                                          <input type="text" [(ngModel)]="schedule.to" name="to{{ i }}" />
                                        </div>
                                      </div>
                                        <div *ngFor="let group of ageGroups">
                                          <h4 style="text-transform: capitalize;">{{ group }}</h4>
                                          <div *ngFor="let charge of schedule[group].charges; let j = index" >
                                            <label>Charge Type: {{ charge.type }}</label>
                                            <div class="col-md-12 row">
                                            <div class="col-md-4">
                                              <label>Amount:</label>
                                              <input
                                                type="text"
                                                (keypress)="onlyNumberKey($event)"
                                                [(ngModel)]="charge.amount"
                                                name="amount{{ i }}{{ group }}{{ j }}"
                                              />
                                            </div>
                                            <div class="col-md-4">
                                              <label>Status:</label>
                                              <mat-select matNativeControl type="s" name="status{{ i }}{{ group }}{{ j }}"   [(ngModel)]="charge.status">
                                                <mat-option class="mat-primary"   value="A">Active</mat-option>
                                                <mat-option class="mat-primary" value="I">Inactive</mat-option>
                                
                                              </mat-select>
                                              <!-- <input
                                                type="text"
                                                [(ngModel)]="charge.status"
                                                
                                              /> -->
                                            </div>
                                            <div class="col-md-4">
                                              <label>Currency:</label>
                                              <input
                                                type="text"
                                                [(ngModel)]="charge.currency"
                                                name="currency{{ i }}{{ group }}{{ j }}"
                                              />
                                            </div>
                                            <div class="col-md-12">
                                              <label>Description:</label>
                                              <textarea
                                                [(ngModel)]="charge.description"
                                                name="description{{ i }}{{ group }}{{ j }}"
                                              ></textarea>
                                            </div>
                                          </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- <button type="submit">Save Schedule</button> -->
                                    </form>
                                  </div>
                       <div class="d-flex justify-content-end">
                        <button *ngIf="addChagerule"  mat-flat-button style="color: black;background-color: #edeef0; margin-right: 8px;" (click)="clearChangeRule()">Clear</button>

                                  <button  mat-flat-button style="color: white;background-color: #1876D0; margin-right: 8px;" (click)="addChangeRule()">Add Change Rule </button>
                                </div>




                                  <!-- <mat-form-field class="col-md-12 mt-2" appearance="outline">
                                    <mat-label style="padding-right: 10px;">Change Rule	</mat-label>
                                    <textarea matInput  rows="3" cols="30"  name="changeRule"  autocomplete="off" formControlName="changeRuleTxt" >
                                    </textarea> -->
                                    <!-- <mat-menu #showDialog="matMenu" (click)="onMenuClick($event)" >
                                      <div class="d-flex justify-content-center col-md-12"  (click)="onMenuClick($event)">
                                        <div class="col-md-10" style="overflow: auto; max-height: 30vh; width: 250px; padding-left: 10px;">
                                        <textarea  id="rule" cols="25" rows="8"></textarea>
                                        </div>
                                      </div>
      
                                      </mat-menu> -->
                                  <!-- </mat-form-field> -->
                                  </mat-tab>
                                  <mat-tab  label="Cancellation Rule">  
                                    <div class="schedule-container">
                                      <form  >
                                        <div style="padding: 15px;" *ngFor="let schedule of scheduleData ; let i = index" [ngClass]="{'odd-row': i % 2 !== 0, 'even-row': i % 2 === 0}">
                                          <h3>Schedule {{ i + 1 }}</h3>
                                          <div class="col-md-12 row">
                                          <div class="col-md-6">
                                            <label>From:</label>
                                            <input type="text" [(ngModel)]="schedule.from" name="from{{ i }}" />
                                          </div>
                                          <div class="col-md-6">
                                            <label>To:</label>
                                            <input type="text" [(ngModel)]="schedule.to" name="to{{ i }}" />
                                          </div>
                                        </div>
                                          <div *ngFor="let group of ageGroups">
                                            <h4 style="text-transform: capitalize;">{{ group }}</h4>
                                            <div *ngFor="let charge of schedule[group].charges; let j = index" >
                                              <label>Charge Type: {{ charge.type }}</label>
                                              <div class="col-md-12 row">
                                              <div class="col-md-4">
                                                <label>Amount:</label>
                                                <input
                                                type="text"
                                                (keypress)="onlyNumberKey($event)"

                                                  [(ngModel)]="charge.amount"
                                                  name="amount{{ i }}{{ group }}{{ j }}"
                                                />
                                              </div>
                                              <div class="col-md-4">
                                                <label>Status:</label>
                                                <mat-select matNativeControl type="s" name="status{{ i }}{{ group }}{{ j }}"   [(ngModel)]="charge.status">
                                                  <mat-option class="mat-primary"   value="A">Active</mat-option>
                                                  <mat-option class="mat-primary" value="I">Inactive</mat-option>
                                  
                                                </mat-select>
                                                <!-- <input
                                                  type="text"
                                                  [(ngModel)]="charge.status"
                                                  
                                                /> -->
                                              </div>
                                              <div class="col-md-4">
                                                <label>Currency:</label>
                                                <input
                                                  type="text"
                                                  [(ngModel)]="charge.currency"
                                                  name="currency{{ i }}{{ group }}{{ j }}"
                                                />
                                              </div>
                                              <div class="col-md-12">
                                                <label>Description:</label>
                                                <textarea
                                                  [(ngModel)]="charge.description"
                                                  name="description{{ i }}{{ group }}{{ j }}"
                                                ></textarea>
                                              </div>
                                            </div>
                                            </div>
                                          </div>
                                        </div>
                                        <!-- <button type="submit">Save Schedule</button> -->
                                      </form>
                                    </div>
                         <div class="d-flex justify-content-end">
                          <button *ngIf="Cancelationrule"  mat-flat-button style="color: black;background-color: #edeef0; margin-right: 8px;" (click)="clearCancelation()">Clear</button>

                                    <button  mat-flat-button style="color: white;background-color: #1876D0; margin-right: 8px;" (click)="addCancelation()">Add Cancellation Rule </button>
                                  </div>




                                    <!-- <mat-form-field class="col-md-12 mt-2" appearance="outline">
                                      <mat-label style="padding-right:12px;">Cancellation Rule		</mat-label>
                                      <textarea matInput  rows="3" cols="30" name="cancellationRule" autocomplete="off" formControlName="cancellationRuleTxt" >
                                     </textarea>
        
                                    </mat-form-field>  -->

</mat-tab>
<mat-tab  label="No Show Rule">  
  
  <mat-form-field class="col-md-12 mt-2" appearance="outline">
    <mat-label style="padding-right: 10px;">No Show Rule		</mat-label>
    <textarea matInput  rows="3" cols="30"name="noShowRule" autocomplete="off" formControlName="noShowRuleTxt" >
</textarea>

  </mat-form-field>
</mat-tab>
<mat-tab  label="Baggage Rule">  
  <mat-form-field class="col-md-12 mt-2" appearance="outline">
    <mat-label style="padding-right: 10px;">Baggage Rule</mat-label>
    <textarea matInput  rows="3" cols="30" matInput name="baggageRule" autocomplete="off" formControlName="baggageRuleTxt" >
</textarea>

  </mat-form-field>
</mat-tab>
<mat-tab  label="Meal">  
  <mat-form-field class="col-md-12 mt-2" appearance="outline">
    <mat-label style="padding-right: 10px;">Meal	</mat-label>
    <textarea matInput  rows="3" cols="30" name="meal" autocomplete="off"  formControlName="mealRuleTxt" >
</textarea>

  </mat-form-field>

</mat-tab>
<mat-tab  label="Seat">  
  <mat-form-field class="col-md-12 mt-2" appearance="outline">
    <mat-label style="padding-right: 10px;">Seat	</mat-label>
    <textarea matInput  rows="3" cols="30" matInput name="seat" autocomplete="off"  formControlName="seatRuleTxt" >
</textarea>

  </mat-form-field>
</mat-tab>
                                
                                </mat-tab-group>
                           
                            <!-- <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Change Fee	</mat-label>
                              <input matInput name="changeFee" autocomplete="off" formControlName="">


                            </mat-form-field>  -->
                            <!-- <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Change Duration		</mat-label>
                              <input matInput name="changeDuration	" autocomplete="off" formControlName="" >


                            </mat-form-field> -->
                           
                            <!-- <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Cancellation Duration		</mat-label>
                              <input matInput name="cancellationDuration" autocomplete="off"  >


                            </mat-form-field> -->
                             
                           
                            <!-- <mat-form-field class="col-md-3" appearance="outline">
                              <mat-label>Frequent Flier	</mat-label>
                              <input matInput name="Frequent" autocomplete="off"  >


                            </mat-form-field> -->
                          
                           
                          </div>         
                            </form>
                      </div>
                      
                     



                      
                      </div>
                      </div>                                      
                </div>
                  <div class="modal-footer">
                    <div class="form-group form-inline ">
                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                    </div>   
                    <button *ngIf="addfare.action==='newFare' && !disabled" class="btn btn-outline-success c-width-100px shadow " (click)="onSubmit()" [disabled]="fareRegFg.invalid">Save</button>
                    <button *ngIf="addfare.action==='updateFare' && !disabled" class="btn btn-outline-success c-width-100px shadow " (click)="onSubmit()">Update</button>
                    <button *ngIf="addfare.action==='newFare' && disabled" class="btn btn-outline-success c-width-100px shadow " disabled>Save</button>
                    <button *ngIf="addfare.action==='updateFare' && disabled" class="btn btn-outline-success c-width-100px shadow " disabled>Update</button>

                    <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                  </div>
                </div>
                </div>
        </div>
    </div>